
import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';
import errorHandler from '../../services/errorHandler';

const buildGroupList = (group, list) => {
  list.push({
    id: group.id,
    name: group.name
  });
  if (!group.children) {
    return list;
  }

  for (let i = 0; i < group.children.length; i++) {
    buildGroupList(group.children[i], list);
  }
  return list;
};

const buildGroupNameMap = (group, map) => {
  if (group.description) {
    map[group.id] = group.name + ' (' + group.description + ')';
  }
  else {
    map[group.id] = group.name;
  }
  if (!group.children) {
    return map;
  }

  for (let i = 0; i < group.children.length; i++) {
    let childMap = buildGroupNameMap(group.children[i], map);
    map = { ...map, ...childMap };
  }
  return map;
};

const state = {
  groups: null,
  selectedGroup: null,
  topLevelGroup: null
}

const mutations = {
  groups (state, groups) {
    state.groups = groups;
  },
  selectGroup(state, group) {
    state.selectedGroup = group;
  },
  topLevelGroup(state, group) {
    state.topLevelGroup = group;
  }
}

const getters = {
  groups: () => state.groups,
  selectedGroup: () => state.selectedGroup,
  topLevelGroup: () => state.topLevelGroup,
  groupNameMap: () => {
    if (!state.groups) {
      return {};
    }
    return buildGroupNameMap(state.groups, {});
  },
  groupList: () => {
    if (!state.groups) {
      return [];
    }
    return buildGroupList(state.groups, []);
  }
}

const actions = {
  async fetchGroups({ commit }, rootGroup) {
    try {
      const response = await ziperase.fetchGroups(rootGroup.id);
      commit('groups', response.data);
    } catch (error) {
      notify().error('Failed to retrieve groups.');
    }
  },
  async createGroup({}, group) {
    try {
      await ziperase.createGroup(group);
      return true;
    } catch (error) {
      let errorMessage = null;
      if (errorHandler.isConflictError(error)) {
        errorMessage = errorHandler.getConflictErrorMessage(error);
      }
      notify().error(errorMessage || 'Failed to create group.');
    }
    return false;
  },
  async updateGroup({ commit }, group) {
    try {
      const response = await ziperase.updateGroup(group.id, group);
      commit('selectGroup', response.data);
      notify().success(`Success! Updated group ${group.name}.`);
      return true;
    } catch (error) {
      let errorMessage = null;
      if (errorHandler.isConflictError(error)) {
        errorMessage = errorHandler.getConflictErrorMessage(error);
      }
      notify().error(errorMessage || `Failed to update group ${group.name}.`);
      return false;
    }
  },
  async toggleActivation({ commit }, group) {
    try {
      let response = null;
      let update = "";
      if (group.is_active) {
        response = await ziperase.deactivateGroup(group.id);
        update = "deactivated";
      } else {
        response = await ziperase.activateGroup(group.id);
        update = "activated";
      }
      commit('selectGroup', response.data);
      notify().success(`Success! ${group.name} has been ${update}.`);
      return true;
    } catch (error) {
      notify().error('Failed to update group.');
    }
    return false;
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
